import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import _ from "lodash";
import {withStyles} from "@material-ui/core/styles";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import Transition from './Transition';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 20px 20px 20px',
		}
	},
	dialogPaper: {
		overflow: 'scroll',
		maxWidth : '100%',
		width: 800,
		height : '95%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	pageImage : {
		width : '100%',
		//height : '100%',
		border : '1px solid #888',
		marginLeft : 10,
	}
});

class InvoiceDocumentPopup extends PureComponent {
	/*
	constructor (props) {
		super(props);
	}
	*/

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const {classes, resourceId, resourceMap, fullScreen } = this.props;

		if (!resourceId) {
			return null;
		}
		const resource = resourceMap[resourceId];


		return (
			<div>
				<Dialog
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
					fullScreen={fullScreen}
					maxWidth='md'
					classes={{
						paper: classes.dialogPaper
					}}
				>
					<DialogTitle>
						<div style={{alignItems : 'center', display : 'flex', justifyContent: 'space-between'}}>
							<Button onClick={this.handleClose}>Close</Button>
						</div>
					</DialogTitle>
					<DialogContent style={{height:'100%'}}>
						<object
							data={resource.url}
							style={{height : '100%', width : '100%', maxWidth : '100%'}}
							type="application/pdf"
							//width="175"
							//height="175"
						>
							<a href={resource.url}>attachment.pdf</a>
						</object>
					</DialogContent>

				</Dialog>
			</div>
		);
	}
}

InvoiceDocumentPopup.propTypes = {
	resourceId : PropTypes.number,
	resourceMap : PropTypes.object,
	open : PropTypes.bool,
	onClose : PropTypes.func,
	fullScreen: PropTypes.bool.isRequired,
	classes : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
])(InvoiceDocumentPopup);